import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  List,
  ListItem,
  ListItemText,
  MenuItem,
  Paper,
  Radio,
  Select,
  Stack,
  Switch,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect, useState, useRef, useMemo } from "react";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import StorageIcon from "@mui/icons-material/Storage";
import { styled } from "@mui/material/styles";
import {
  useFetchPrincipalEntitiesdataQuery,
  useGetFilterReportsQuery,
  useGetSearchFilesQuery,
} from "../../../../store/services/principleApi";
import { useFetchHeadersByPrincipalIdQuery } from "../../../../store/services/headerApi ";
import dayjs from "dayjs";
import * as XLSX from "xlsx";
import { toast } from "react-toastify";
import { formatedCurrentDateTime } from "../../../../utility/GetCurrentDateTime";
import api from "../../../../Appjs/api";
import {
  useLazyCheckSpamKeywordsQuery,
  usePreviewcustomizeDataMutation,
  useUploadBulkSMSMutation,
  useUploadCustomizeMutation,
} from "../../../../store/services/smsApi";
import { useGetTemplateByPrincipalIdQuery } from "../../../../store/services/templateApi";
import { io } from "socket.io-client";
import socketApi from "../../../../Appjs/socketApi";
import { useGetCustomerCountriesQuery } from "../../../../store/services/blacklistApi";
import Loader from "../../../common/Loader";
import { maskNumber } from "../../../common/Encryption";
import { ClearIcon } from "@mui/x-date-pickers";
import {
  useCheckMpinStatusQuery,
  useVerifyMpinStatusMutation,
} from "../../../../store/services/userApi";
import { Table } from "react-bootstrap";
import { Preview } from "@mui/icons-material";
import { useDataEnableServiceQuery } from "../../../../store/services/flowApi";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

// ── Shared sizing tokens (matches BulkSMS) ───────────────────────────────────
const FIELD_HEIGHT = 35;
const FORM_MAX_WIDTH = 510;

// Shows first 3 + "..." + last 3 characters
const trimPeId = (id) => {
  const str = String(id ?? "");
  if (str.length <= 6) return str;
  return `${str.slice(0, 3)}...${str.slice(-3)}`;
};

// Tighter dropdown options (matches BulkSMS)
const compactMenuProps = {
  PaperProps: {
    sx: {
      "& .MuiMenuItem-root": {
        minHeight: 28,
        py: 0.25,
        px: 1.5,
        fontSize: "0.8rem",
      },
    },
  },
  MenuListProps: { dense: true, sx: { py: 0.5 } },
};

// ── Shared glass token (matches BulkSMS) ─────────────────────────────────────
const glassField = {
  height: FIELD_HEIGHT,
  fontSize: "0.8rem",
  background: "rgba(255,255,255,0.7)",
  backdropFilter: "blur(8px)",
  borderRadius: "8px",
  "&:hover": { boxShadow: "0 4px 12px rgba(0,0,0,0.05)" },
};

const Customize = ({ service_id, onPreviewChange }) => {
  // ── ALL STATE UNCHANGED ───────────────────────────────────────────────────
  const [socket, setSocket] = useState(null);
  const [smsType, setSmsType] = useState(() => localStorage.getItem("smsType") || "english");
  const [isReviewModalOpen, setIsReviewModalOpen] = useState(false);
  const [reviewData, setReviewData] = useState(null);
  const [isSubmit, setIsSubmit] = useState(false);
  const [smstext, setSmsText] = useState("");
  const [charCountState, setCharCountState] = useState(0);
  const [smsCountState, setSmsCountState] = useState(0);
  const [selectedFile, setSelectedFile] = useState(null);
  const [filterDatatill_days, setFilterDatatill_days] = useState('');
  const [templateId, setTemplateId] = useState("");
  const [peId, setPeId] = useState("");
  const [error, setError] = useState("");
  const fileInputRef = useRef(null);
  const [isAllow, setIsAllow] = useState(false);
  const [countdownTimer, setCountdownTimer] = useState(null);
  const [fileNames, setFileNames] = useState("");
  const [file, setFile] = useState(null);
  const [phoneNumbers, setPhoneNumbers] = useState("");
  const [entityId, setEntityId] = useState(null);
  const [showSpamWarning, setShowSpamWarning] = useState(false);
  const [spamKeywords, setSpamKeywords] = useState([]);
  const [prId, setPrId] = useState(null);
  const [isPrincipalEntitySelected, setIsPrincipalEntitySelected] = useState(false);
  const [headers, setHeaders] = useState([]);
  const [enableFilterTill, setEnableFilterTill] = React.useState(false);
  const [templates, setTemplates] = useState([]);
  const [principalEntities, setPrincipalEntities] = useState([]);
  const [headerName, setHeaderName] = useState("");
  const [selectedTemplateName, setSelectedTemplateName] = useState("");
  const [isTransliterationEnabled, setIsTransliterationEnabled] = useState(false);
  const [transliterationControl, setTransliterationControl] = useState(null);
  const [languages, setLanguages] = useState([]);
  const [isLongMessageWarning, setIsLongMessageWarning] = useState(false);
  const [alertShown, setAlertShown] = useState(false);
  const [isTemplateModalOpen, setIsTemplateModalOpen] = useState(false);
  const [templateSearch, setTemplateSearch] = useState("");
  const [isFlash, setIsFlash] = useState(false);
  const [enableSchedule, setEnableSchedule] = useState(false);
  const [smsCount, setSmsCount] = useState(1);
  const [charCount, setCharCount] = useState(0);
  const [postVia, setPostVia] = useState("");
  const [isCountryModalOpen, setIsCountryModalOpen] = useState(false);
  const [isCountrySelected, setIsCountrySelected] = useState(true);
  const [currentLanguage, setCurrentLanguage] = useState("hi");
  const [isFileModalOpen, setIsFileModalOpen] = useState(false);
  const [selectedDbFile, setSelectedDbFile] = useState(null);
  const [previewCustomizeData, { data }] = usePreviewcustomizeDataMutation();
  const { data: dbFiles, isLoading: dbFilesLoading } = useGetSearchFilesQuery();
  const { data: filterReports, isLoading: filterLoading } = useGetFilterReportsQuery();
  const { data: dataEnableRes } = useDataEnableServiceQuery();

  console.log("dbFiles", data?.results?.totalremains);

  const [dateTime, setDateTime] = useState(dayjs(new Date()).format("YYYY-MM-DDTHH:mm"));
  const [sendTime, setSendTime] = useState(
    enableSchedule ? dayjs(dateTime).format("YYYY-MM-DD HH:mm") : dayjs(new Date()).format("YYYY-MM-DD HH:mm")
  );
  const [minDateTime, setMinDateTime] = useState(dayjs().format("YYYY-MM-DDTHH:mm"));
  const [selectedCountry, setSelectedCountry] = useState({ id: 1, name: "India", code: "+91" });
  const [mpinModalOpen, setMpinModalOpen] = useState(false);
  const [mpin, setMpin] = useState("");
  const [mpinError, setMpinError] = useState("");
  const [isSubmittingAfterMpin, setIsSubmittingAfterMpin] = useState(false);

  // ── ALL HOOKS UNCHANGED ───────────────────────────────────────────────────
  const { data: headersData, isLoading: headersLoading, isError: headersError } =
    useFetchHeadersByPrincipalIdQuery(prId, { skip: !prId });
  const { data: principalEntitiesData, isLoading, isError } = useFetchPrincipalEntitiesdataQuery();
  const { data: checkmpin, refetch: refetchmpin } = useCheckMpinStatusQuery();
  const [verifyMpin, { isLoading: isVerifyingMpin }] = useVerifyMpinStatusMutation();
  console.log({ checkmpin: checkmpin?.data });
  const { data: countriesData, isLoading: countriesLoading, isError: countriesError } = useGetCustomerCountriesQuery();
  const [checkSpamKeywords, { data: spamCheckData, isFetching: isCheckingSpam }] = useLazyCheckSpamKeywordsQuery();
  const { data: templatesData, isLoading: templatesLoading, isError: templatesError } =
    useGetTemplateByPrincipalIdQuery(prId, { skip: !prId });
  const [uploadCustomize, { isLoading: bulkIsLoading }] = useUploadCustomizeMutation();

  // ── ALL EFFECTS UNCHANGED ─────────────────────────────────────────────────
  useEffect(() => {
    if (principalEntitiesData) setPrincipalEntities(principalEntitiesData.data || []);
  }, [principalEntitiesData]);

  useEffect(() => {
    const list = headersData?.data || [];
    setHeaders(list);
  }, [headersData, prId]);

  useEffect(() => {
    const newSocket = io(socketApi, { transports: ["websocket"], secure: true });
    console.log({ newSocket });
    setSocket(newSocket);
    newSocket.on("connect", () => console.log("Connected to Socket.IO server"));
    newSocket.on("disconnect", () => console.log("Disconnected from Socket.IO server"));
    newSocket.on("sendSMSResponse", (data) => console.log("Received sendSMS response:", data));
    return () => newSocket.disconnect();
  }, []);

  useEffect(() => {
    const list = templatesData?.data || [];
    setTemplates(list);
    setTemplateId("");
  }, [templatesData, prId]);

  const filteredTemplates = templates.filter((template) =>
    (template.template_name || "")
      .toLowerCase()
      .includes(templateSearch.trim().toLowerCase()),
  );

  useEffect(() => {
    if (!onPreviewChange) return;
    onPreviewChange({
      entity: entityId?.pe_name
        ? `${entityId.pe_name} (${entityId.pe_id ? trimPeId(entityId.pe_id) : ""})`
        : "",
      senderId: headerName || "",
      templateName: selectedTemplateName || "",
      templateId: templateId || "",
      file: file ? file.name : "",
      dbFile: selectedDbFile ? selectedDbFile.filter_name : "",
      additionalNumbers: phoneNumbers ? `${phoneNumbers.split("\n").filter(Boolean).length} numbers` : "",
      message: smstext || "",
      smsType: smsType || "",
      schedule: enableSchedule ? sendTime : "Immediately",
      allowLong: !!isAllow,
      isFlash: !!isFlash,
      charCount: charCountState || 0,
      smsCount: smsCountState || 0,
    });
  }, [entityId, headerName, selectedTemplateName, templateId, file, selectedDbFile, phoneNumbers,
    smstext, smsType, enableSchedule, sendTime, isAllow, isFlash, charCountState, smsCountState, onPreviewChange]);

  // ── ALL HANDLERS UNCHANGED ────────────────────────────────────────────────
  const handleCountryModalToggle = () => setIsCountryModalOpen(!isCountryModalOpen);

  const uniqueCountries = useMemo(() => {
    const list = countriesData?.data || [];
    const map = new Map();
    list.forEach((item) => {
      const id = Number(item.country_id);
      if (!map.has(id)) map.set(id, { id, name: item?.country?.country_name || "", code: (item?.country?.countrycode || "").trim() });
    });
    return Array.from(map.values());
  }, [countriesData]);

  const handlepreviewSubmit = async () => {
    const formData = new FormData();
    formData.append("noofdays", String(filterDatatill_days));
    formData.append("customer_id", "");
    formData.append("filterdatatill_days", filterDatatill_days);
    formData.append("country_code", selectedCountry.code);
    formData.append("smsCount", smsCountState || 0);
    formData.append("charCount", charCountState || 0);
    formData.append("service_id", service_id || 1);
    formData.append("country_id", selectedCountry.id || 1);

    if (file) {
      formData.append("file", file);
    } else if (selectedDbFile) {
      const cleanPath = (selectedDbFile.file_path || selectedDbFile.path).replace(/\\/g, "/");
      formData.append("filePath", cleanPath);
      formData.append("customer_requestid", selectedDbFile.customer_requestid || "");
    }

    try {
      const res = await previewCustomizeData(formData).unwrap();
      if (res?.success === false) {
        toast.error(res?.error || "Something went wrong");
        return false;
      }
      return true;
    } catch (error) {
      toast.error(error?.data?.error || "Preview failed");
      return false;
    }
  };

  const handleSubmitFile = (days) => {
    if (!selectedFile) { alert("Please select a file first!"); return; }
    const payload = { ...selectedFile, filterdatatill_days: days };
    console.log("Submitting payload:", payload);
  };

  const handleReviewClick = async () => {
    if (!isPrincipalEntitySelected) { toast.error("Please select a PRINCIPAL ENTITY."); return; }
    if (!headerName) { toast.error("Please select a template to get header name"); return; }
    if (!file && !selectedDbFile) { toast.error("Please upload a file or select from database"); return; }
    if (smsType === "english" && checkForUnicodeCharacters(smstext)) {
      toast.error("Unicode characters are not allowed in English SMS. Please remove them or select 'Other SMS' (हिंदी व अन्य भाषाएँ)."); return;
    }
    try {
      console.log("Checking spam for text:", smstext);
      const spamCheck = await checkSpamKeywords(smstext).unwrap();
      if (spamCheck?.status === false && spamCheck?.data?.length > 0) {
        setSpamKeywords(spamCheck.data); setShowSpamWarning(true);
        toast.warn(`Spam keywords found: ${spamCheck.data.join(", ")}`); return;
      }
      const data = {
        entity: entityId?.pe_name
          ? `${entityId.pe_name} (${entityId.pe_id ? trimPeId(entityId.pe_id) : ""})`
          : "Not selected",
        senderId: headerName || "Not selected",
        smsType, smstext,
        templateId: templateId ? maskNumber(templateId) : "None",
        country: `${selectedCountry.name} (${selectedCountry.code})`,
        allowLongMessage: isAllow ? "Yes" : "No",
        isFlash: isFlash ? "Yes" : "No",
        schedule: enableSchedule ? sendTime : "Immediately",
        file: selectedDbFile ? `From DB: ${selectedDbFile.path}` : file ? file.name : "No file uploaded",
        charCount: charCountState, smsCount: smsCountState,
        spamKeywords: spamCheck?.data || [],
      };
      setReviewData(data); setIsReviewModalOpen(true);
    } catch (error) {
      console.error("Error checking spam keywords:", error);
      toast.error("Failed to check for spam keywords. Please try again.");
    }
  };

  const handleFinalSubmit = async () => {
    try {
    } catch (error) {
      console.error("MPIN Status Error:", error);
      toast.error("Failed to check MPIN status. Proceeding without verification.");
      submitSMS();
    }
  };

  const handleDbFileSelect = (file) => {
    setFile(null);
    if (fileInputRef.current) fileInputRef.current.value = "";
    setSelectedDbFile(file);
    setFileNames(`From DB: ${file.filter_name}`);
    setIsFileModalOpen(false);
  };

  const submitSMS = async () => {
    const currentDateTime = formatedCurrentDateTime();
    setIsSubmit(true);
    const formData = new FormData();
    try {
      const res = await formData;
      if (res?.data?.status) { }
    } catch (error) {
    } finally { setIsSubmittingAfterMpin(false); setIsSubmit(false); }
  };

  const handleCountrySelect = (countryId, countryName, countrycode) => {
    const cleanCountryCode = countrycode.trim();
    setSelectedCountry({ id: countryId, name: countryName, code: cleanCountryCode });
    setIsCountrySelected(true);
    const mobileInput = document.getElementById("mobile");
    if (mobileInput?.value?.startsWith(cleanCountryCode))
      mobileInput.value = mobileInput.value.replace(cleanCountryCode, "").trim();
  };

  const handleSmsTypeChange = (event) => {
    const selectedValue = event.target.value;
    setSmsType(selectedValue);
    if (selectedValue === "other") setSmsText("");
    setSmsText(""); setCharCountState(0); setSmsCountState(0);
    setTemplateId(""); setPeId(""); setIsAllow(false); setCountdownTimer(null);
  };

  const MAX_ALLOWED_NUMBERS = 1000000;

  const handleFileChange = (event) => {
    const files = event.target.files;
    if (!files || files.length === 0) { setFile(null); setSelectedDbFile(null); setFileNames(""); return; }
    const selectedFile = files[0];
    setSelectedDbFile(null);
    if (!selectedFile) return;
    const fileExtension = selectedFile.name.split(".").pop().toLowerCase();
    if (!["txt", "csv"].includes(fileExtension)) {
      setError("Only .txt or .csv files are allowed."); setFile(null); setSelectedDbFile(null);
      setFileNames(""); event.target.value = ""; return;
    }
    const reader = new FileReader();
    reader.onload = (e) => {
      let content = e.target.result;
      if (fileExtension === "xlsx") {
        try {
          const workbook = XLSX.read(content, { type: "binary" });
          content = XLSX.utils.sheet_to_csv(workbook.Sheets[workbook.SheetNames[0]]);
        } catch (err) { setError("Failed to read XLSX file."); setFile(null); setSelectedDbFile(null); setFileNames(""); event.target.value = ""; return; }
      }
      const numberArray = content.split(/[\n,\s]+/).map(n => n.trim()).filter(n => /^\d{10,}$/.test(n));
      if (numberArray.length > MAX_ALLOWED_NUMBERS) { setError("File contains more than 10 lakh numbers."); setFile(null); setFileNames(""); event.target.value = ""; return; }
      setSelectedDbFile(null); setFile(selectedFile); setFileNames(`${selectedFile.name} `); setError("");
    };
    if (fileExtension === "xlsx") reader.readAsBinaryString(selectedFile);
    else reader.readAsText(selectedFile);
  };

  const handleEntityChange = (e) => {
    const selectedEntityId = e.target.value;
    setEntityId(selectedEntityId);
    console.log("Selected Entity:", selectedEntityId);
    console.log("Setting prId to:", selectedEntityId.principalentity_id);
    setPrId(selectedEntityId.principalentity_id);
    setIsPrincipalEntitySelected(!!selectedEntityId);
    setHeaderName(""); setHeaders([]);
    setPeId(selectedEntityId.pe_id); setSmsText(""); setTemplateId("");
    setCharCountState(0); setSmsCountState(0); setTemplates([]);
    setSelectedTemplateName("");
  };

  const transliterateStateChangeHandler = (e) => setIsTransliterationEnabled(e.transliterationEnabled);

  useEffect(() => {
    const loadTransliterationAPI = () => google.load("elements", "1", { packages: "transliteration", callback: onLoad });
    const script = document.createElement("script");
    script.src = "https://www.google.com/jsapi"; script.onload = loadTransliterationAPI;
    document.body.appendChild(script);
  }, []);

  const onLoad = () => {
    const el = document.getElementById("txtMessage");
    if (!el) { setTimeout(onLoad, 100); return; }
    const options = {
      sourceLanguage: "en",
      destinationLanguage: ["hi", "ar", "bn", "fa", "gu", "kn", "ml", "mr", "ne", "pa", "ta", "te", "ur"],
      transliterationEnabled: false, shortcutKey: "ctrl+g",
    };
    const control = new google.elements.transliteration.TransliterationControl(options);
    setTransliterationControl(control);
    control.makeTransliteratable(["txtMessage"]);
    setIsTransliterationEnabled(control.isTransliterationEnabled());
    setLanguages(google.elements.transliteration.getDestinationLanguages(google.elements.transliteration.LanguageCode.ENGLISH));
    control.addEventListener(google.elements.transliteration.TransliterationControl.EventType.STATE_CHANGED, transliterateStateChangeHandler);
  };

  const checkboxClickHandler = () => {
    if (transliterationControl) {
      transliterationControl.toggleTransliteration();
      const isEnabled = transliterationControl.isTransliterationEnabled();
      setIsTransliterationEnabled(isEnabled);
      if (isEnabled) { setCurrentLanguage("hi"); transliterationControl.setLanguagePair(google.elements.transliteration.LanguageCode.ENGLISH, "hi"); }
    }
  };

  const languageChangeHandler = (event) => {
    setCurrentLanguage(event.target.value);
    if (transliterationControl) transliterationControl.setLanguagePair(google.elements.transliteration.LanguageCode.ENGLISH, event.target.value);
  };

  const checkForUnicodeCharacters = (text) => smsType !== "english" ? false : getUnicodeCharacters(text).length > 0;

  function getUnicodeCharacters(sentence) {
    const unicodeChars = [];
    for (const char of sentence) {
      const codePoint = char.codePointAt(0);
      if (codePoint > 127) unicodeChars.push({ codePoint, char, code: "U+" + codePoint.toString(16).toUpperCase().padStart(4, "0") });
    }
    const unique = []; const seen = new Set();
    for (const u of unicodeChars) { if (!seen.has(u.char)) { seen.add(u.char); unique.push(u); } }
    return unique;
  }

  const handleSmsTextChange = (e) => {
    const text = e.target.value; setSmsText(text);
    const trimmedText = text.trimEnd();
    if (smsType === "english") {
      const hasUnicode = checkForUnicodeCharacters(trimmedText);
      if (hasUnicode) {
        const charsList = getUnicodeCharacters(trimmedText).map(u => u.char).join(", ");
        alert(`Unicode characters (${charsList}) are not allowed in English SMS. Please remove them or select "Other SMS" (हिंदी व अन्य भाषाएँ).`);
      }
    }
    let newCharCount = 0;
    const specialSymbols = ["^", "|", "{", "}", "[", "]", "\\", "~"];
    for (let i = 0; i < trimmedText.length; i++) newCharCount += specialSymbols.includes(trimmedText[i]) ? 2 : 1;
    setCharCountState(newCharCount);
    let smsCount = 1;
    if (smsType === "english") { if (newCharCount <= 160) smsCount = 1; else if (newCharCount <= 306) smsCount = 2; else smsCount = Math.ceil(newCharCount / 153); }
    else { if (newCharCount <= 70) smsCount = 1; else if (newCharCount <= 134) smsCount = 2; else smsCount = Math.ceil(newCharCount / 67); }
    setSmsCountState(smsCount);
    const singleSmsLimit = smsType === "english" ? 160 : 70;
    if (newCharCount > singleSmsLimit && !isAllow) {
      setIsAllow(true); setIsLongMessageWarning(true);
      if (!alertShown) { alert(`Message exceeds ${singleSmsLimit} characters and will take multiple SMS! "Allow Long Message"`); setAlertShown(true); }
    } else if (newCharCount <= singleSmsLimit && isAllow) { setIsAllow(false); setIsLongMessageWarning(false); }
    else setIsLongMessageWarning(false);
  };

  const handleTemplateSelect = (templateText, templateId, templateName, headerId) => {
    setSmsText(templateText);
    setTemplateId(templateId);
    setSelectedTemplateName(templateName);

    if (headerId) {
      const header = headers.find(h => h.header_id === headerId);
      if (header) {
        setHeaderName(header.header_name);
      } else {
        setHeaderName("");
      }
    } else {
      setHeaderName("");
    }

    setIsTemplateModalOpen(false);
    handleSmsTextChange({ target: { value: templateText } });
  };

  console.log({ file, socket });
  console.log("data.results", data?.results);

  const handleSubmit = async () => {
    setIsSubmit(true);
    const currentDateTime = formatedCurrentDateTime();
    if (!isPrincipalEntitySelected) { toast.error("Please select a PRINCIPAL ENTITY."); setIsSubmit(false); return; }
    if (!headerName) { toast.error("Please select a template to get header name"); setIsSubmit(false); return; }
    if (enableSchedule && dayjs(sendTime).isBefore(dayjs())) { toast.error("Schedule time cannot be in the past"); return; }
    if (!dateTime) { toast.error("Please select a date and time for the message."); setIsSubmit(false); return; }
    const payload = {
      smstext: (smstext || "").trimEnd(),
      template_id: templateId || "0",
      header_name: headerName || "",
      pe_id: entityId?.pe_id,
      country_id: selectedCountry?.id || "",
      country_code: selectedCountry?.code,
      post_via: "customize",
      is_flash: isFlash,
      language: smsType,
      allowLongSms: isAllow,
      smsCount: Number(smsCountState),
      charCount: charCountState,
      service_id: service_id,
      filterDatatill_days: filterDatatill_days,
      total_numbers: data?.results?.totalremains || 0,
    };
    if (enableSchedule) payload.time_to_send = sendTime;

    if (selectedDbFile) {
      payload.file_source = "chooseDb";
      payload.upload_file_path = selectedDbFile.path;
      payload.originalFileName =
        selectedDbFile.originalName || selectedDbFile.filter_name;
      payload.customer_requestid = selectedDbFile.customer_requestid || "";
    }

    else if (file) {
      payload.file_source = "uploadFile";

      if (data?.results?.outfilepath) {
        payload.upload_file_path = data.results.outfilepath;
      } else {
        payload.upload_file = file;
      }

      payload.originalFileName = file.name;
    }
    const mobileNumberInput = document.getElementById("mobile")?.value.trim();
    if (mobileNumberInput && mobileNumberInput !== "") {
      const formattedNumbers = mobileNumberInput.split("\n").map(num => num.replace(selectedCountry.code, "").trim()).filter(num => num !== "");
      payload.phone_number = formattedNumbers.join(",");
    }
    console.log("Payload =>", payload);
    try {
      const res = await uploadCustomize(payload);
      console.log({ res: res?.data });
      if (res?.data?.status) {
        setIsSubmit(false); toast.success("Data uploaded successfully!");
        setIsReviewModalOpen(false); setMpinModalOpen(false);
        setPhoneNumbers(""); setFile(null); setEntityId(null); setHeaderName("");
        setTemplates([]); setPrId(null); setEnableSchedule(false); setTemplateId(""); setSmsText("");
        setSmsCount(1); setCharCount(0); setSmsCountState(0); setCharCountState(0);
        setPeId(""); setPostVia(""); setIsFlash(false); setIsAllow(false); setSendTime(formatedCurrentDateTime());
        setSelectedTemplateName("");
      }
    } catch (error) {
      setIsSubmit(false);
      if (error.response) toast.error(error.response.data.message || "An error occurred while uploading the data.");
      else toast.error("An error occurred while uploading the data.");
      console.error("API Error:", error);
    }
  };

  console.log({ isTransliterationEnabled });

  const handleConfrimSubmit = async () => {
    if (checkmpin?.data?.allow_mpin) setMpinModalOpen(true);
    else handleSubmit();
  };

  const verifyMpinHandler = async () => {
    try {
      const response = await verifyMpin({ mpin_pass: mpin });
      console.log({ response });
      if (response?.data?.status) {
        setMpinModalOpen(false); setIsReviewModalOpen(false);
        setTimeout(async () => { await handleSubmit(); }, 1000);
      } else setMpinError(response.data.message || "Verification failed");
    } catch (error) {
      console.error("MPIN Verification Error:", error);
      if (error.status === 404) toast.error("MPIN verification endpoint not found");
      else if (error.data?.message) setMpinError(error.data.message);
      else setMpinError("Invalid MPIN ");
    }
  };

  if (bulkIsLoading) return <Loader />;

  return (
    <>
      {/* ── SMS Language ─────────────────────────────────────────────────── */}
      <Box sx={{ mt: 1 }}>
        <FormControl size="small" sx={{ minWidth: 100 }}>
          <InputLabel id="smsType-label" sx={{ fontSize: "0.8rem" }}>SMS Language</InputLabel>
          <Select
            labelId="smsType-label" id="smsType" value={smsType} label="SMS Language"
            onChange={handleSmsTypeChange}
            MenuProps={compactMenuProps}
            sx={{ ...glassField, "& .MuiSelect-select": { fontSize: "0.8rem" } }}
          >
            <MenuItem value="english" sx={{ fontSize: "0.8rem" }}>English Lang</MenuItem>
            <MenuItem value="other" sx={{ fontSize: "0.8rem" }}>Other Lang</MenuItem>
          </Select>
        </FormControl>
      </Box>

      {/* ── Main Row (compact) ───────────────────────────────────────────── */}
      <Box sx={{ display: "flex", mt: 1.5, gap: 2, alignItems: "flex-start", maxWidth: FORM_MAX_WIDTH }}>

        {/* Left Column — flexible, fixed-width controls */}
        <Stack sx={{ flex: 1, minWidth: 0 }}>

          {/* Entity dropdown — reduced width; pe_name truncates, pe_id always visible */}
          <Box
            sx={{
              display: "flex",
              gap: 1.5,
              mb: 1,
              flexWrap: "wrap",
              alignItems: "center",
            }}
          >
            <FormControl sx={{ width: 190 }}>
              <InputLabel id="entityId-label" sx={{ fontSize: "0.8rem" }}>Entity Id</InputLabel>
              <Select
                labelId="entityId-label"
                id="entityId-label"
                label="Entity Id"
                value={entityId}
                onChange={handleEntityChange}
                size="medium"
                MenuProps={compactMenuProps}
                sx={glassField}
                /* ── pe_name truncates with ellipsis, but pe_id stays visible to its last digit ── */
                renderValue={(selected) => {
                  if (!selected?.pe_id) return "Select Entity Id";
                  return (
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 0.5,
                        minWidth: 0,
                        fontSize: "0.8rem",
                      }}
                    >
                      <Box
                        sx={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          minWidth: 0,
                        }}
                      >
                        {selected.pe_name}
                      </Box>
                      <Box sx={{ flexShrink: 0, whiteSpace: "nowrap" }}>
                        ({trimPeId(selected.pe_id)})
                      </Box>
                    </Box>
                  );
                }}
              >
                <MenuItem value="" sx={{ fontSize: "0.8rem" }}>Select Entity Id</MenuItem>
                {isLoading ? <MenuItem disabled sx={{ fontSize: "0.8rem" }}>Loading...</MenuItem>
                  : isError ? <MenuItem disabled sx={{ fontSize: "0.8rem" }}>No Entities Available</MenuItem>
                    : principalEntities.length > 0
                      ? principalEntities.map((entity, index) => (
                        <MenuItem key={index} value={entity} sx={{ fontSize: "0.8rem" }}>
                          {entity.pe_name} ({trimPeId(entity.pe_id)})
                        </MenuItem>
                      ))
                      : <MenuItem disabled sx={{ fontSize: "0.8rem" }}>No Entities Available</MenuItem>}
              </Select>
            </FormControl>

            {/* UploadFile + ChooseDB — compact, side-by-side (BulkSMS style) */}
            <Stack direction="row" spacing={1} sx={{ width: 220, alignItems: "center" }}>
              <Button component="label" variant="outlined" startIcon={<CloudUploadIcon />}
                sx={{
                  flex: 1,
                  minWidth: 0,
                  height: FIELD_HEIGHT,
                  px: 1,
                  textTransform: "none",
                  fontSize: "0.75rem",
                  whiteSpace: "nowrap",
                  background: "rgba(255,255,255,0.7)",
                  backdropFilter: "blur(8px)",
                  borderRadius: "8px",
                  "& .MuiButton-startIcon": { mr: 0.5 },
                  "&:hover": { background: "rgba(255,255,255,0.9)", boxShadow: "0 4px 12px rgba(0,0,0,0.05)" },
                }}>
                <Tooltip title={file ? file.name : ""} arrow>
                  <Box
                    component="span"
                    sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", display: "block" }}
                  >
                    {file
                      ? file.name.length > 12
                        ? file.name.substring(0, 12) + "..."
                        : file.name
                      : "UploadFile"}
                  </Box>
                </Tooltip>
                <VisuallyHiddenInput type="file" id="fileUpload" accept=".txt,.csv" onChange={handleFileChange} ref={fileInputRef} />
              </Button>

              {dataEnableRes?.isdataenable !== null && (
                <Button variant="outlined" startIcon={<StorageIcon />} onClick={() => setIsFileModalOpen(true)}
                  sx={{
                    flex: 1,
                    minWidth: 0,
                    height: FIELD_HEIGHT,
                    px: 1,
                    textTransform: "none",
                    fontSize: "0.75rem",
                    whiteSpace: "nowrap",
                    background: "rgba(255,255,255,0.7)",
                    backdropFilter: "blur(8px)",
                    borderRadius: "8px",
                    "& .MuiButton-startIcon": { mr: 0.5 },
                    "&:hover": { background: "rgba(255,255,255,0.9)", boxShadow: "0 4px 12px rgba(0,0,0,0.05)" },
                  }}>
                  <Tooltip title={selectedDbFile ? selectedDbFile.filter_name : ""} arrow>
                    <Box
                      component="span"
                      sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", display: "block" }}
                    >
                      {selectedDbFile ? selectedDbFile.filter_name : "ChooseDB"}
                    </Box>
                  </Tooltip>
                </Button>
              )}
            </Stack>
          </Box>

          {error && <Typography variant="body2" color="error" sx={{ mt: 0.5, fontSize: "0.7rem" }}>{error}</Typography>}

          {/* Filter From LC */}
          <Box sx={{ mb: 1 }}>
            {checkmpin?.data?.allow7_day_filter && (
              <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
                <FormControlLabel
                  control={<Switch size="small" checked={enableFilterTill}
                    onChange={(e) => { setEnableFilterTill(e.target.checked); if (!e.target.checked) setFilterDatatill_days(0); }} />}
                  label="Filter From LC"
                  sx={{ m: 0, "& .MuiFormControlLabel-label": { fontSize: "0.75rem", color: "#000" } }}
                />
                {enableFilterTill && (
                  <FormControl size="small" sx={{ width: 130 }}>
                    <InputLabel sx={{ fontSize: "0.7rem" }}>Filter Till</InputLabel>
                    <Select value={filterDatatill_days} label="Filter Till"
                      onChange={(e) => setFilterDatatill_days(e.target.value)}
                      MenuProps={compactMenuProps}
                      sx={{ fontSize: "0.75rem", height: 28, background: "rgba(255,255,255,0.7)", backdropFilter: "blur(8px)", borderRadius: "6px" }}>
                      <MenuItem value={1} sx={{ fontSize: "0.75rem" }}>Today</MenuItem>
                      <MenuItem value={2} sx={{ fontSize: "0.75rem" }}>Yesterday</MenuItem>
                      {Array.from({ length: 28 }, (_, i) => i + 3).map(d => (
                        <MenuItem key={d} value={d} sx={{ fontSize: "0.75rem" }}>Last {d} days</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}
              </Box>
            )}
          </Box>
        </Stack>


      </Box>

      {/* ── Message Area ─────────────────────────────────────────────────── */}
      <Box>
        {smsType === "other" && (
          <Box>
            <FormControlLabel
              control={<Checkbox checked={isTransliterationEnabled} onChange={checkboxClickHandler} sx={{ p: 0.5 }} />}
              label="Enable Text Editor:"
              componentsProps={{ typography: { fontSize: "0.75rem", color: "#000" } }}
            />
            {isTransliterationEnabled && (
              <Select onChange={languageChangeHandler} disabled={!isTransliterationEnabled} size="small"
                label="Language" value={currentLanguage}
                MenuProps={compactMenuProps}
                sx={{ minWidth: 30, mb: 1, fontSize: "0.7rem", background: "rgba(255,255,255,0.7)", borderRadius: "6px" }}>
                {Object.entries(languages).map(([key, value]) => (
                  <MenuItem key={value} value={value} sx={{ fontSize: "0.7rem" }}>{key}</MenuItem>
                ))}
              </Select>
            )}
          </Box>
        )}

        {selectedTemplateName && (
          <Typography variant="subtitle2" sx={{ fontSize: "0.75rem", color: "#666", fontWeight: "bold" }}>
            Template Name: {selectedTemplateName}
          </Typography>
        )}

        <TextField
          label="Message"
          id="txtMessage" value={smstext} onChange={handleSmsTextChange} name="txtMessage"
          multiline rows={3}
          placeholder={smsType === "other" ? "70 Character Message Enter" : "160 Character Message Enter"}
          variant="outlined" margin="normal"
          sx={{
            width: "100%",
            maxWidth: FORM_MAX_WIDTH,
            "& .MuiOutlinedInput-root": { background: "rgba(255,255,255,0.7)", backdropFilter: "blur(8px)" },
          }}
          helperText={
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mt: 0.5 }}>
              <Button size="small" variant="contained" color="primary" onClick={() => setIsTemplateModalOpen(true)}
                sx={{ textTransform: "none", fontSize: "0.7rem", px: 1, py: 0.5 }}>
                Open Template
              </Button>
              <Box sx={{ fontSize: "0.7rem", color: "red" }}>
                Counts may vary depending on the variable length of the uploaded file.
              </Box>
              <FormControlLabel
                control={<Checkbox checked={isAllow} onChange={(e) => setIsAllow(e.target.checked)} size="small" sx={{ p: 0.5 }} />}
                label="Allow Long Message"
                sx={{ "& .MuiFormControlLabel-label": { fontSize: "0.7rem", color: "#000" } }}
              />
            </Box>
          }
          FormHelperTextProps={{ sx: { margin: 0 } }}
        />
      </Box>

      {/* ── Flash & Schedule ─────────────────────────────────────────────── */}
      <Box display="flex" alignItems="center" gap={2} mt={1}>
        <FormControlLabel
          control={<Checkbox checked={isFlash} onChange={(e) => setIsFlash(e.target.checked)} size="small" sx={{ p: 0.5 }} />}
          label="Is Flash"
          sx={{ "& .MuiFormControlLabel-label": { fontSize: "0.8rem", color: "#000" } }}
        />
        <Box display="flex" alignItems="center" gap={1}>
          <FormControlLabel
            control={
              <Checkbox checked={enableSchedule} size="small" sx={{ p: 0.5 }}
                onChange={(e) => {
                  const isChecked = e.target.checked; setEnableSchedule(isChecked);
                  if (!isChecked) {
                    const now = dayjs().format("YYYY-DD-MM HH:mm");
                    setDateTime(now); setSendTime(now);
                  } else setMinDateTime(dayjs().format("YYYY-DD-MMTHH:mm"));
                }}
              />
            }
            label="Schedule For Later?"
            sx={{ "& .MuiFormControlLabel-label": { fontSize: "0.8rem", color: "#000" } }}
          />
          {enableSchedule && (
            <TextField label="Schedule Date" type="datetime-local" value={sendTime}
              onChange={(e) => {
                const v = e.target.value; const now = dayjs().format("YYYY-MM-DDTHH:mm");
                if (dayjs(v).isBefore(now)) { toast.error("Schedule time cannot be in the past"); setSendTime(now); }
                else setSendTime(v);
              }}
              size="small" InputLabelProps={{ shrink: true }} inputProps={{ min: minDateTime }}
              sx={{ width: 200, "& .MuiInputBase-root": { fontSize: "0.8rem", background: "rgba(255,255,255,0.7)" }, "& .MuiInputLabel-root": { fontSize: "0.8rem" } }}
            />
          )}
        </Box>
      </Box>

      {/* ── Country & Preview ────────────────────────────────────────────── */}
      <Box display="flex" alignItems="center" gap={2} mt={2}>
        <div className="flex items-center text-[0.8rem]">
          <label className="block font-medium ml-3 text-[0.8rem]">Select Country</label>
          <div className="py-2 ms-3">
            {selectedCountry
              ? <span className="text-blue-500 cursor-pointer underline" onClick={handleCountryModalToggle}>{selectedCountry.name} ({selectedCountry.code})</span>
              : <button onClick={handleCountryModalToggle} className="text-blue-500 underline">Select Country</button>}
          </div>
          {isCountryModalOpen && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
              <div className="bg-white p-6 rounded-lg max-w-sm w-full relative">
                <h2 className="text-xl font-semibold mb-4 text-[0.8rem]">Select Country</h2>
                <button onClick={() => setIsCountryModalOpen(false)} className="absolute top-2 right-2 text-gray-500 hover:text-gray-800">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
                {countriesLoading ? <p>Loading countries...</p>
                  : countriesError ? <p>No countries available</p>
                    : (
                      <div className="max-h-96 overflow-y-auto">
                        {countriesData?.data?.length > 0
                          ? uniqueCountries.map(country => (
                            <div key={country.id} onClick={() => handleCountrySelect(country.id, country.name, country.code)}
                              className={`p-3 mb-2 cursor-pointer rounded hover:bg-gray-100 ${selectedCountry?.id === country.id ? "bg-blue-100" : ""}`}>
                              {country.name} ({country.code})
                            </div>
                          ))
                          : <p>No countries available</p>}
                      </div>
                    )}
              </div>
            </div>
          )}
        </div>
        <Button variant="outlined" color="primary" size="medium"
          onClick={async () => {
            const isValid = await handlepreviewSubmit();
            if (!isValid) return;
            handleReviewClick();
          }}
          sx={{ textTransform: "none", fontSize: "0.8rem", px: 2 }}>
          Preview
        </Button>
      </Box>

      {/* ── Review Modal ─────────────────────────────────────────────────── */}
      {isReviewModalOpen && (
        <Dialog open={isReviewModalOpen} onClose={() => setIsReviewModalOpen(false)} fullWidth maxWidth="md">
          <DialogTitle>Review Your SMS Details</DialogTitle>
          <DialogContent dividers>
            {!data || !reviewData ? (
              <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: 200 }}>
                <CircularProgress />
              </Box>
            ) : (
              <>
                {data?.results && (
                  <Box mb={2}>
                    <Typography variant="h6" gutterBottom>Processing Results</Typography>
                    <Grid container spacing={1}>
                      {[
                        { label: "Total Posted", value: data.results.totalposted },
                        { label: "Total Remains", value: data.results.totalremains },
                        { label: "Last Campaign Filter", value: data.results.totalsevendaysfilter },
                        { label: "Global Blacklist", value: data.results.totalglobalblacklist },
                        { label: "Customer Blacklist", value: data.results.totalcustomerblacklist },
                        { label: "Duplicates", value: data.results.totalduplicates },
                        { label: "Estimated Cost", value: data.results.total_cost },
                      ].map(({ label, value }) => (
                        <Grid key={label} item xs={6} md={2}>
                          <Paper variant="outlined" sx={{ p: 0.75, borderRadius: 1.5, textAlign: "center" }}>
                            <Typography variant="caption" color="text.secondary" display="block">{label}</Typography>
                            <Typography variant="body2" fontWeight="bold">{value ?? "-"}</Typography>
                          </Paper>
                        </Grid>
                      ))}
                    </Grid>
                  </Box>
                )}
                {reviewData?.spamKeywords?.length > 0 && (
                  <Box sx={{ backgroundColor: "#fff3cd", color: "#856404", p: 2, borderRadius: 1, mb: 2 }}>
                    <Typography variant="subtitle1" fontWeight="bold">Warning: Spam Keywords Detected</Typography>
                    <Typography variant="body2">The following keywords may trigger spam filters: {reviewData.spamKeywords.join(", ")}</Typography>
                  </Box>
                )}
                <Box>
                  <Typography variant="h6" gutterBottom>SMS Details</Typography>
                  <Grid container spacing={2}>
                    {[
                      { label: "Entity", value: reviewData?.entity },
                      { label: "Header Name", value: reviewData?.senderId },
                      { label: "SMS Type", value: reviewData?.smsType === "english" ? "English" : "Other Languages" },
                      { label: "Message", value: <Box sx={{ whiteSpace: "pre-wrap" }}>{reviewData?.smstext}</Box> },
                      { label: "No of Days", value: filterDatatill_days || "0" },
                      { label: "Additional Numbers", value: reviewData?.phoneNumbers || "None" },
                      { label: "Allow Long Message", value: reviewData?.allowLongMessage || (isAllow ? "Yes" : "No") },
                      { label: "Is Flash", value: reviewData?.isFlash || (isFlash ? "Yes" : "No") },
                      { label: "Message Stats", value: `${reviewData?.charCount} characters | ${reviewData?.smsCount} SMS` },
                    ].map(({ label, value }) => (
                      <Grid key={label} item xs={12} md={4}>
                        <Paper variant="outlined" sx={{ p: 1, borderRadius: 2 }}>
                          <Typography variant="body2" color="text.secondary">{label}</Typography>
                          <Typography variant="subtitle2" fontWeight="bold">{value ?? "-"}</Typography>
                        </Paper>
                      </Grid>
                    ))}
                  </Grid>
                </Box>
              </>
            )}
          </DialogContent>
          <strong style={{ color: data?.results?.is_campaign_ready === "yes" ? "green" : "red", textAlign: "center" }}>
            {data?.results?.message}
          </strong>
          <DialogActions>
            <Button onClick={() => setIsReviewModalOpen(false)}>Edit</Button>
            <Button variant="contained" color="primary" onClick={handleConfrimSubmit}
              disabled={!data || !reviewData || !data?.results?.totalremains || data?.results?.is_campaign_ready !== "yes"}>
              Confirm & Submit
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {/* ── MPIN Modal ───────────────────────────────────────────────────── */}
      <Dialog open={mpinModalOpen} onClose={() => setMpinModalOpen(false)}>
        <DialogTitle>Enter MPIN</DialogTitle>
        <DialogContent>
          <Typography variant="body1" sx={{ mb: 2 }}>MPIN verification is required to proceed</Typography>
          <TextField autoFocus margin="dense" label="Enter MPIN" type="password" fullWidth variant="outlined"
            value={mpin} onChange={(e) => { setMpin(e.target.value); setMpinError(""); }}
            error={!!mpinError} helperText={mpinError} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => { setMpinModalOpen(false); setIsSubmittingAfterMpin(false); }}>Cancel</Button>
          <Button onClick={verifyMpinHandler} color="primary" disabled={isVerifyingMpin}>
            {isVerifyingMpin ? <CircularProgress size={24} /> : "Verify"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── Template Modal ───────────────────────────────────────────────── */}
      {isTemplateModalOpen && (
        <Dialog
          open={isTemplateModalOpen}
          onClose={() => { setIsTemplateModalOpen(false); setTemplateSearch(""); }}
        >
          <DialogTitle sx={{ fontSize: "0.75rem", fontWeight: "bold", pb: 0.5 }}>Select Template</DialogTitle>
          <DialogContent>
            <TextField
              fullWidth
              size="small"
              label="Search template by name"
              value={templateSearch}
              onChange={(e) => setTemplateSearch(e.target.value)}
              sx={{ mb: 1.5 }}
            />
            {templatesLoading ? <CircularProgress />
              : templatesError ? <Typography color="error">Error loading templates</Typography>
                : filteredTemplates.length > 0
                  ? <List sx={{ backgroundColor: "#fff", p: 0 }}>{filteredTemplates.map(template => (
                    <ListItem button key={template.template_id}
                      sx={{ mb: 1, backgroundColor: "#fff", border: "1px solid #e0e0e0", borderRadius: 1, "&:hover": { backgroundColor: "#f5f5f5" } }}
                      onClick={() => {
                        handleTemplateSelect(
                          template.template_text,
                          template.trai_template_id,
                          template.template_name,
                          template.header_id
                        );
                      }}>
                      <ListItemText
                        primary={
                          <>
                            <span style={{ fontSize: "0.75rem", fontWeight: "bold" }}>
                              Template Name: {template.template_name}
                            </span>
                            <br />
                            <span style={{ fontSize: "0.75rem" }}>{template.template_text}</span>
                          </>
                        }
                        secondary={
                          <>
                            <span style={{ fontSize: "0.7rem" }}>ID: {maskNumber(template.trai_template_id)}</span>
                            {template.header_id && (
                              <>
                                <br />
                                <span style={{ fontSize: "0.7rem", color: "#1976d2" }}>
                                  Header: {headers.find(h => h.header_id === template.header_id)?.header_name || "Unknown"}
                                </span>
                              </>
                            )}
                          </>
                        }
                      />
                    </ListItem>
                  ))}</List>
                    : <Typography>{templateSearch ? "No templates match your search" : "No templates available"}</Typography>}
          </DialogContent>
                  <DialogActions><Button onClick={() => { setIsTemplateModalOpen(false); setTemplateSearch(""); }}>Close</Button></DialogActions>
        </Dialog>
      )}

      {/* ── DB File Modal ────────────────────────────────────────────────── */}
      {isFileModalOpen && (
        <Dialog open={isFileModalOpen} onClose={() => setIsFileModalOpen(false)} maxWidth={false}
          sx={{ "& .MuiDialog-paper": { width: { xs: "95vw", sm: "60vw", md: "50vw" }, maxHeight: "80vh" } }}>
          <DialogTitle sx={{ fontSize: "0.8rem", fontWeight: "bold" }}>Select File From Database</DialogTitle>
          <DialogContent>
            {dbFilesLoading
              ? <Box sx={{ display: "flex", justifyContent: "center" }}><CircularProgress /></Box>
              : dbFiles?.data?.length > 0
                ? <Box sx={{ width: "100%" }}>
                  <TableContainer>
                    <Table>
                      <TableHead sx={{ bgcolor: "#0288d1", "& th": { color: "white", fontSize: "0.75rem", borderBottom: "0.5px solid #B0B0B0" } }}>
                        <TableRow>
                          {["Sr.No", "Filter Name", "File No", "Total Count", "Request ID", "Fields In File", "Created At", "Select"].map(h => (
                            <TableCell key={h} sx={{ textAlign: "center", borderRight: "0.5px solid #B0B0B0" }}>{h}</TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {dbFiles.data.map((file, index) => (
                          <TableRow key={file.path}>
                            {[index + 1, file.filter_name, file.page_no, file.totalcount, file.customer_requestid, file.fieldsinfile, dayjs(file.createdat).format("DD/MM/YYYY")].map((val, ci) => (
                              <TableCell key={ci} sx={{ padding: "8px", textAlign: "center", borderRight: "0.5px solid #B0B0B0", fontSize: "0.75rem" }}>{val}</TableCell>
                            ))}
                            <TableCell sx={{ padding: "8px", borderRight: "0.5px solid #B0B0B0" }}>
                              <Radio size="small" checked={selectedDbFile?.path === file.path} onChange={() => setSelectedDbFile(file)} />
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  {selectedDbFile && (
                    <Box sx={{ mt: 2, textAlign: "right" }}>
                      <Button size="small" variant="contained"
                        onClick={() => handleDbFileSelect(selectedDbFile)}>
                        Submit
                      </Button>
                    </Box>
                  )}
                </Box>
                : <Typography>No files available in database</Typography>}
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};

export default Customize;